import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Input from '@xingternal/malt-input';
import FormField from '@xingternal/malt-form-field';
import styles from './TextInput.css';

/**
 * You can pass any HTML attributes and any handler into the component.
 * They will be passed along to the `@xingternal/malt-input` that is used in here.
 * Some attributes were explicitly allowed in earlier versions, but we decided to
 * simply pass them through to the input field instead of allowing more and more
 * standard elements through white-listing.
 *
 * Please check the explicitly defined props as well – some toggle
 * CSS classes or are needed for specific actions within the input (e.g. `disabled`).
 * They shouldn't get into your way in any case, though.
 */

const TextInput = ({
  className = undefined,
  inputClassName = undefined,
  onClear = undefined,
  value = undefined,
  disabled = undefined,
  label = undefined,
  message = undefined,
  hintMessage = undefined,
  testId = undefined,
  inputRef = undefined,
  ...inputProps
}) => (
  <FormField
    className={classnames(styles.container, className)}
    testId={testId}
    label={label}
    errorMessage={message}
    hintMessage={hintMessage}
  >
    <Input
      value={value}
      onClear={onClear}
      disabled={disabled}
      hasError={!!message}
      className={inputClassName}
      inputRef={inputRef}
      {...inputProps}
    />
  </FormField>
);

TextInput.displayName = 'TextInput';

TextInput.propTypes = {
  /** add a custom className to the container div */
  className: PropTypes.string,
  /** add a custom className to the input */
  inputClassName: PropTypes.string,
  /** callback for the clear button */
  onClear: PropTypes.func,
  /** contains the content of the input */
  value: PropTypes.string,
  /** disabled the text input */
  disabled: PropTypes.bool,
  /** renders a label above the text input */
  label: PropTypes.node,
  /** provide an error message for the input. Is this used the text input will automatically turn invalid. */
  message: PropTypes.node,
  /** provide a hint message for the input. Overridden if errorMessage is present. */
  hintMessage: PropTypes.node,
  /** define a testid for the text input */
  testId: PropTypes.string,
  /** callback to store a reference to the DOM element */
  inputRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};

export default TextInput;
